export default __webpack_public_path__ + "static/media/ico-aws-s-3-bucket-circle-solid.afc0b11c.svg";